import { t } from "@/i18n-js/instance";
import { OpenQPModal } from "@/react/components/QuickPost/OpenQPModal";

export const HomePageNewPostButton = () => (
  <OpenQPModal
    id="sidebar--right__btn-quick-post"
    hasIcon={false}
    linkName={t("new_post")}
  />
);
